import React from "react";
export const GlobalContext = React.createContext();
export const MetaContext = React.createContext();
export const IframeContext = React.createContext();
